import React from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import BgIcon from "../../../images/bg-icon.svg"
import JobsImg from "../../../images/jobs-img.svg"

const JobsOpening = () => {
  const data = useStaticQuery(graphql`
    query {
      allRestApiOpenV3CareerPageAvalithJobs {
        nodes {
          results {
            id
            hash
            organization_name
            position_name
            description
            location_display
          }
        }
      }
    }
  `)
  const result = data.allRestApiOpenV3CareerPageAvalithJobs.nodes[0].results
  
  return (
    <section className="container mx-auto px-6 pb-8">
      <h3 className="text-5xl pb-8 font-normal leading-tight">
        <span className="text-secondary block font-bold">Open</span> positions
      </h3>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {result.map(job => {
          const text = job.description
          //const clearText = text.replace(/(<([^>]+)>)/gi, "")
          //const descripcion = clearText.replace(/(&nbsp;)/gi, " ")
          const descripcion = text.replace(/ style="\w+[-\w+:; ,().#&'\\]+"/g, "")
          const clearText = descripcion.substring(0, 320)+"..."
          return (
            <div
              key={job.id}
              className="border-gray-800 border-8 rounded-3xl p-6"
            >
              <div>
                <div
                  className="bg-center bg-no-repeat text-white inline-flex p-6 text-lg"
                  style={{ backgroundImage: `url(${BgIcon})` }}
                >
                  Open
                </div>
                <div>
                  <img
                    src={JobsImg}
                    alt={job.position_name}
                    className="float-right inline"
                  />
                  <h5 className="text-2xl font-semibold py-4">
                    {job.position_name}
                  </h5>
                  <div className="pb-8" dangerouslySetInnerHTML={{ __html: clearText }} />
                </div>
                <p className="text-center pb-8">        
                  <Link to={`/careers/open-seat/${job.id}`} title={job.position_name} className="mx-auto lg:mr-5 lg:mx-0 my-8 hover:text-white hover:bg-secondary hover:text-variant btn">Ver detalles</Link>
                </p>
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}

export default JobsOpening